import { api } from "@/libs/api-client";
import type { ApiDataResponse } from "@/types/api-types";
import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import type { Following } from "../types";

export const getFollowersSchema = z.object({
  userId: z.string(),
});

export type GetFollowersInput = z.infer<typeof getFollowersSchema>;

export const getFollowers = createServerFn({ method: "GET" })
  .validator(getFollowersSchema)
  .handler<Following[]>(async ({ data }) => {
    const response = await api
      .post("user/getFollowers", {
        searchParams: {
          userId: data.userId,
        },
      })
      .json<
        ApiDataResponse<
          {
            userId: string;
            userName: string;
            nickName: string;
            introduction: string;
            avatarUrl: string;
            level: number;
            followingCount: number;
            followerCount: number;
          }[]
        >
      >();

    return response.data.map((following) => ({
      userId: following.userId,
      username: following.userName,
      nickname: following.nickName,
      bio: following.introduction ?? "",
      avatarUrl: following.avatarUrl,
      followerCount: following.followerCount,
      followingCount: following.followingCount,
    }));
  });
